"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actions = {
    toggleInCallPip: 'DISPLAY_TOGGLE_INCALL_PIP',
    togglePipPreview: 'DISPLAY_TOGGLE_PIP_PREVIEW',
    togglePresentationPrompt: 'DISPLAY_TOGGLE_PRESENTATION_PROMPT',
    changeVolumeInCall: 'CHANGE_VOLUME_IN_CALL',
    setIsLegacyServiceDegraded: 'SET_IS_LEGACY_SERVICE_DEGRADED',
    setHdmiPresentationConnected: 'SET_HDMI_PRESENTATION_CONNECTED',
    setHdmiPresentationActive: 'SET_HDMI_PRESENTATION_ACTIVE',
    startHdmiPresentation: 'START_HDMI_PRESENTATION',
    stopHdmiPresentation: 'STOP_HDMI_PRESENTATION',
    startSharePresentation: 'START_SHARE_PRESENTATION',
    stopSharePresentation: 'STOP_SHARE_PRESENTATION',
    setSharePresentationInfo: 'SET_SHARE_PRESENTATION_INFO',
    setSharePinCode: 'SET_SHARE_PIN_CODE',
    setSharePresentationActive: 'SET_SHARE_PRESENTATION_ACTIVE',
    setSipIncomingCall: 'SET_SIP_INCOMING_CALL',
    setSipActiveCall: 'SET_SIP_ACTIVE_CALL',
    endSip: 'END_SIP',
    selectCallLayout: 'SELECT_CALL_LAYOUT',
    showMeetingStartPrompt: 'SHOW_MEETING_START_PROMPT',
    setRaiseHandErrors: 'SET_RAISE_HAND_ERRORS',
    clearRaiseHandErrors: 'CLEAR_RAISE_HAND_ERRORS',
    selectParticipant: 'SELECT_PARTICIPANT'
};
exports.deviceCameraActions = {
    panLeft: 'CAMERA_PAN_LEFT',
    panRight: 'CAMERA_PAN_RIGHT',
    zoomIn: 'CAMERA_ZOOM_IN',
    zoomOut: 'CAMERA_ZOOM_OUT',
    tiltUp: 'CAMERAL_TILT_UP',
    tiltDown: 'CAMERA_TILT_DOWN',
    panLeftStop: 'CAMERA_PAN_LEFT_STOP',
    panRightStop: 'CAMERA_PAN_RIGHT_STOP',
    zoomInStop: 'CAMERA_ZOOM_IN_STOP',
    zoomOutStop: 'CAMERA_ZOOM_OUT_STOP',
    tiltUpStop: 'CAMERA_TILT_UP_STOP',
    tiltDownStop: 'CAMERA_TILT_DOWN_STOP',
    setPreset: 'CAMERA_SET_PRESET',
    renamePreset: 'CAMERA_RENAME_PRESET',
    deletePreset: 'CAMERA_DELETE_PRESET',
    moveToPreset: 'CAMERA_MOVE_TO_PRESET'
};
exports.errors = {
    RAISE_HAND_FAILED: 'RAISE_HAND_FAILED',
    LOWER_HAND_FAILED: 'LOWER_HAND_FAILED',
    LOWER_ALL_HANDS_FAILED: 'LOWER_ALL_HANDS_FAILED',
    LOWER_PARTICIPANT_HAND_FAILED: 'LOWER_PARTICIPANT_HAND_FAILED'
};
